<template>
  <div id="detail" class="h-screen navbar-sticky" @contextmenu.prevent>
    <the-navbar :navbarColor="navbarColor" :showLogo="true" :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]" />
    <div class="learn">
      <div class="learn-header">
        <vs-button color="rgb(43 44 45)" type="filled" icon-pack="feather" icon="icon-arrow-left" @click="backToContents">返回课程目录</vs-button>
      </div>
      <div class="learn-body vx-row mt-4 mx-0">
        <div class="left md:w-4/5 w-full h-full" ref="left">
          <div v-if="showStudyStatus" class="w-full h-full">
            <study-status-list :chapterId="chapter.id" />
          </div>
          <div v-else-if="showStudentTask" class="w-full h-full">
            <student-task-list :taskId="taskId" :taskName="taskName" :chapterId="chapter.id" :courseId="courseId" />
          </div>
          <div v-else-if="!showStudyStatus && (videos.length > 0 || teachPlans.length > 0 || coursewares.length > 0)" class="w-full h-full">
            <video-player 
              v-if="resource[resourceIndex].type == 0" 
              ref="player" 
              :options="playerOptions" 
              :playsinline="true"
              @play="finishResource(resource[resourceIndex].id)" 
            />
            <iframe v-else-if="resource[resourceIndex].type == 1 || resource[resourceIndex].type == 2 || resource[resourceIndex].type == 3" :src="`/pdfjs/web/viewer.html?file=${resource[resourceIndex].url}`" frameborder="0" class="pdf-wrap"></iframe>
          </div>
          <div v-else class="flex flex-col justify-center items-center h-full">
            <img class="no-resource" :src="require('@/assets/images/chapter/no-resource.png')" alt="">
            <p class="text-xl mt-2">老师还未发送课件，请联系老师</p>
          </div>
          <div class="task-btn-wrap md:block hidden">
            <vs-button 
              color="rgb(255,162,28)" 
              v-if="$acl.get[0] == 'student' && tasks.length > 0 && resource[resourceIndex].type == 3" 
              @click="openScratch(resource[resourceIndex])">开始任务</vs-button>
            <div
              class=""
              v-if="$acl.check('teacher') && !showStudyStatus && !showStudentTask && tasks.length > 0 && resource[resourceIndex].type == 3"
            >
              <vs-button color="success" class="mr-2" @click="openScratch({'project_id': resource[resourceIndex].project_id})">项目预览</vs-button>
              <vs-button 
              color="rgb(255,162,28)" 
              @click="openTaskList(resource[resourceIndex].id, resource[resourceIndex].title)">任务评分</vs-button>
            </div>
          </div>
        </div>
        <div class="right md:w-1/5 w-full h-full md:flex flex-col justify-between hidden overflow-y-auto">
          <div>
            <vs-collapse>
              <vs-collapse-item v-if="videos.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group8.png')" alt="视频">
                  <span>视频</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in videos" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="teachPlans.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group6.png')" alt="教案">
                  <span>教案</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in teachPlans" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="coursewares.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group7.png')" alt="课件">
                  <span>课件</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in coursewares" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="tasks.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group14.png')" alt="任务单">
                  <span>任务单</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in tasks" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="other.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group11.png')" alt="其他">
                  <span>其他</span>
                </div>
                <ul>
                  <li class="py-2 flex justify-between items-center" 
                    :class="item.active?'active':''" 
                    v-for="item in other" 
                    :key="item.id"
                  >
                    {{ item.title }}
                    <vs-button color="rgb(255,162,28)" size="small" @click="downloadFile(item)">下载</vs-button>
                  </li>
                </ul>
              </vs-collapse-item>
            </vs-collapse>
            <div v-if="$acl.check('teacher')" class="flex items-center p-4 text-lg cursor-pointer" @click="showStudyStatus = true;showStudentTask = false;resourceIndex = 0">
              <img class="w-8 mr-4" :src="require('@/assets/images/chapter/study-status-icon.png')" alt="学习情况">
              <span>学习情况</span>
            </div>
            <div v-if="$acl.check('teacher') && project.init" class="flex items-center p-4 text-lg cursor-pointer" @click="openTaskList(project.init.resource_id, '课堂练习')">
              <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group9.png')" alt="课堂练习情况">
              <span>练习情况</span>
            </div>
          </div>
          <div class="text-center" v-if="$acl.check('teacher')">
            <vs-button class="mb-4" type="border" color="rgb(255,162,28)" @click="showDistributePrompt">发送资料</vs-button>
          </div>
        </div>
      </div>
      <div class="learn-footer flex flex-wrap justify-between items-center mt-4">
        <div class="chapter-info">
          <span class="chapter-name">{{ chapter.name }}</span>
          <p class="chapter-brief">简介：{{ chapter.brief }}</p>
        </div>
        <div class="flex flex-wrap md:flex hidden">
          <vs-button color="rgb(255,162,28)" type="filled" class="mr-4"  v-if="$acl.check('teacher') && project.init" @click="createPrompt = true">去创作</vs-button>
          <vs-button color="rgb(255,162,28)" type="filled" class="mr-4"  v-if="$acl.get[0] == 'student' && project.init" @click="openScratch(project.init)">去创作</vs-button>
        </div>
      </div>
    </div>

    <div id="resource-sidebar" class="md:hidden">
      <vs-sidebar position-right parent="#detail" default-index="-1"  color="primary" class="sidebarx" spacer v-model="resourceSidebarActive">
        <div class="flex flex-col justify-between" style="height:100%">
          <div>
            <vs-collapse>
              <vs-collapse-item v-if="videos.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group8.png')" alt="视频">
                  <span>视频</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in videos" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="teachPlans.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group6.png')" alt="教案">
                  <span>教案</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in teachPlans" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="coursewares.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group7.png')" alt="课件">
                  <span>课件</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in coursewares" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="tasks.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group14.png')" alt="任务单">
                  <span>任务单</span>
                </div>
                <ul>
                  <li class="py-2" 
                    :class="item.active?'active':''" 
                    v-for="item in tasks" 
                    :key="item.id"
                    @click="showResource(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </vs-collapse-item>
              <vs-collapse-item v-if="other.length > 0">
                <div slot="header" class="flex items-center">
                  <img class="w-8 mr-4" :src="require('@/assets/images/chapter/Group11.png')" alt="其他">
                  <span>其他</span>
                </div>
                <ul>
                  <li class="py-2 flex justify-between" 
                    :class="item.active?'active':''" 
                    v-for="item in other" 
                    :key="item.id"
                  >
                    
                    {{ item.title }}
                    <vs-button color="rgb(255,162,28)" size="small" @click="downloadFile(item)">下载</vs-button>
                  </li>
                </ul>
              </vs-collapse-item>
            </vs-collapse>
            <p class="p-4">温馨提示：如果要进行创作，请使用电脑打开本页面喔！</p>
          </div>
          <div class="text-center" v-if="$acl.check('teacher')">
            <vs-button class="mb-4" type="border" color="rgb(255,162,28)" @click="showDistributePrompt">发送资料</vs-button>
          </div>
        </div>
      </vs-sidebar>
      <vs-button class="sidebar-btn" color="warning" icon-pack="feather" icon="icon-eye" @click="resourceSidebarActive = true"></vs-button>
    </div>

    <!-- 批量发送资料 -->
    <vs-prompt
      vs-title="批量发送资料"
      :vs-buttons-hidden="true"
      :vs-active.sync="distributeResourcePrompt"
      @vs-close="closeDistributeResourcePrompt"
    >
      <div class="con-exemple-prompt">
        <div class="vx-row my-4" style="border-top: 1px solid #ccc;border-bottom: 1px solid #ccc;">
          <div class="vx-col w-1/2" style="border-right: 1px solid #ccc;">
            <p class="mt-2">选择资料</p>
            <v-tree ref="treeResource" :data='resourceTreeData' :halfcheck='true' :multiple='true' />
          </div>
          <div class="vx-col w-1/2">
            <p class="mt-2">选择学生</p>
            <v-tree ref="treeStudent" :data='studentTreeData' :halfcheck='true' :multiple='true' />
          </div>
        </div>
        <div class="flex justify-end">
          <vs-button type="filled" color="primary" @click="postSendResource">发送</vs-button>
        </div>
      </div>
    </vs-prompt>

    <!-- 去创作 -->
    <vs-prompt
      vs-title="创作项目"
      :vs-buttons-hidden="true"
      :vs-active.sync="createPrompt"
      @vs-close="closeCreatePrompt"
    >
      <div class="con-exemple-prompt">
        <div class="vx-row my-4 h-24">
          <div class="vx-col w-1/2 flex justify-center" style="border-right: 1px dashed #ccc;">
            <vs-button color="warning"  @click="openScratch(project.init)">初始项目</vs-button>
          </div>
          <div class="vx-col w-1/2 flex justify-center">
            <vs-button color="primary" @click="openScratch(project.complete)">完整项目</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>

import axios from 'axios'
import config from '@/config'
import { chapterDetail, studentFinishResource } from '@/api/course'
import { getStudentTree, sendResourceToStu } from '@/api/school'
import themeConfig from '@/../themeConfig.js'
import TheNavbar from '@/layouts/components/TheNavbar.vue'

import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

import { VTree}  from 'vue-tree-halower'
import StudyStatusList from './components/StudyStatusList.vue'
import StudentTaskList from './components/StudentTaskList.vue'

export default {
  components: {
    TheNavbar,
    videoPlayer,
    VTree,
    StudyStatusList,
    StudentTaskList,
  },
  data() {
    return {
      navbarColor: themeConfig.navbarColor || '#fff',
      isNavbarDark: false,
      courseId: 0,
      chapter: {
        id: 0,
        name: '',
        brief: '',
      },
      resource: [],
      resourceIndex: 0,
      playerOptions: {
        height: '360',
        autoplay: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{ type: "video/mp4", src: "http://vjs.zencdn.net/v/oceans.mp4" }],
      },
      distributeResourcePrompt: false,
      distributeMode: 'class',
      resourceTreeData: [{
        title: '全部',
        expanded: true,
        children: [],
      }],
      currentClassId: 0,
      studentTreeData: [
        {
          title: '全部',
          expanded: true,
          children: [],
        }
      ],
      createPrompt: false,
      resourceSidebarActive: false,
      showStudyStatus: false,
      project: {
        init: null,
        complete: null
      },
      taskId: 0,
      taskName: '',
      showStudentTask: false,
    }
  },
  created() {
    
  },
  mounted() {
    let that = this
    this.chapter.id = this.$route.query.id
    this.courseId = this.$route.query.courseId
    this.init()
    this.$nextTick(function () {
      that.playerOptions.height = that.$refs.left.offsetHeight
    })
    // window.onresize = () => {
    //   that.playerOptions.height = that.$refs.left.offsetHeight
    // }
  },
  computed: {
    isThemeDark(val) {
      if(this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a")
      }else {
        this.updateNavbarColor("#fff")
      }
    },
    videos() {
      return  this.resource.filter(item => {
                return item.type == 0
              })
    },
    coursewares() {
      return  this.resource.filter(item => {
                return item.type == 1
              })
    },
    teachPlans() {
      return  this.resource.filter(item => {
                return item.type == 2
              })
    },
    tasks() {
      return this.resource.filter(item => {
                return item.type == 3
              })
    },
    other() {
      return this.resource.filter(item => {
                return item.type == 5
              })
    },
  },
  methods: {
    init() {
      chapterDetail({id: this.chapter.id}).then(res => {
        if (res.code == 1) {
          this.chapter = res.data.chapter
          this.resource = res.data.resource
          this.project = res.data.project
          if (this.resource.length > 0 && this.resource[this.resourceIndex].type == 0) {
            this.playerOptions.sources[0].src = this.resource[this.resourceIndex].url
          }
          // 生成资源树
          this.resourceTreeData[0].children = this.resource.filter(item => {
            return item.type == 1 || item.type == 0 || item.type == 3 || item.type == 5
          })
        }
      })
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if(val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    backToContents() {
      this.$router.push({path: '/courseCenter/contents', query: {id: this.courseId}})
    },
    showResource(item) {
      // 设置资源选中
      let key = Object.keys(this.resource).find(k => this.resource[k].id == item.id)
      this.resource.map(item => {
        item.active = false
        return item
      })
      this.resourceIndex = key
      this.resource[key].active = true
      sessionStorage.setItem('resourceUrl', this.resource[key].url)
      if (this.resource[key].type == 0) {
        this.playerOptions.sources[0].src = this.resource[key].url
      } else if (this.resource[key].type == 1) {
        // 默认打开pdf就已经学习 视频则点击播发后才是已学习
        this.finishResource(this.resource[key].id)
      }
      this.resource = Object.assign([], this.resource)
      this.showStudyStatus = false
      this.showStudentTask = false
    },
    closeDistributeResourcePrompt() {
      this.distributeResourcePrompt = false
    },
    showDistributePrompt() {
      this.distributeResourcePrompt = true
      this.getClassList()
    },
    getClassList() {
      getStudentTree().then(res => {
        if (res.code == 1) {
          this.studentTreeData = res.data.tree
        }
      })
    },
    postSendResource() {
      let resources = this.$refs.treeResource.getCheckedNodes().filter(item => {
        return item.type !== undefined
      }).map(item => item.id)
      let students = this.$refs.treeStudent.getCheckedNodes().filter(item => {
        return item.id !== undefined
      }).map(item => item.id)
      if (resources.length == 0) {
        this.$vs.notify({
          color: "warning",
          text: "请选择资源",
          title: "提示",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return false
      }
      if (students.length == 0) {
        this.$vs.notify({
          color: "warning",
          text: "请选择学生",
          title: "提示",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return false
      }
      sendResourceToStu({
        course_id: this.courseId,
        chapter_id: this.chapter.id,
        resources: resources,
        students: students
      }).then(res => {
        if (res.code == 1) {
          this.$vs.notify({
            color: "success",
            text: "添加成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.closeDistributeResourcePrompt();
        }
      })
    },
    closeCreatePrompt() {
      this.createPrompt = false
    },
    finishResource(id) {
      if (this.$acl.get[0] == 'student') {
        studentFinishResource({
          chapter_id: this.chapter.id,
          resource_id: id
        }).then(res => {
          console.log(res)
        })
      }
    },
    openScratch(project) {
      if (!project) {
        window.open(config.scratchUrl, '_blank')
      } else {
        window.open(config.scratchUrl+'?edit#'+project.project_id, '_blank')
      }
    },
    downloadFile(file) {
      axios.get(file.url, { responseType: 'blob'}).then(res => {
          if (!res.data) {
            this.$vs.notify({
              color:'error', 
              text: '下载失败',
              title: '提示',
              iconPack: 'feather',
              icon: 'icon-alert-circle'  
            })
            return
          }
          let url = window.URL.createObjectURL(new Blob([res.data]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', file.name?file.name:file.title)

          document.body.appendChild(link)
          link.click()
          // 释放资源及移除节点（用完就丢）
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
      }).catch(err => {
          console.log('err:', err)
      })
    },
    openTaskList(taskId, name) {
      this.taskId = taskId
      this.taskName = name
      this.showStudentTask = true
      this.showStudyStatus = false
      this.resourceIndex = 0
    }
  },
  
  
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/extraComponents/tree.scss";
  #detail {
    height: 100%;
    background: #333;
    .vx-navbar-wrapper {
      width: 100% !important;
    }
    .vs-navbar.vx-navbar {
      width: 100% !important;
    }
    .vs-sidebar {
      position: fixed;
      z-index: 43000;
      .vs-collapse {
        padding: 0;
        .con-content--item {
          padding: 0;
          li {
            padding: 1rem;
          }
          li.active {
            background: #eee;
          }
          li:hover {
            background: #eee;
          }
        }
      }
    }
  }
  .learn {
    padding-top: 6.7rem;
    padding-left: 2rem;
    padding-right: 2rem;
    height: 100%;
    min-height: 100%;
    background: #333;
    .learn-body {
      height: 75%;
      .left {
        position: relative;
        overflow: hidden;
        border-radius: 6px 0 0 6px;
        .video-player {
          .video-js {
            width: 100% !important;
          }
        }
        .pdf-wrap {
          width: 100%;
          height: 100%;
        }
        .task-btn-wrap {
          position: absolute;
          right: 3rem;
          bottom: 1rem;
        }
      }
      .right {
        color: #fff;
        font-weight: 200;
        .vs-collapse {
          padding: 0;
          .con-content--item {
            padding: 0;
            li {
              padding: 1rem;
            }
            li.active {
              background: #525252;
            }
            li:hover {
              background: #8a8a8a;
            }
          }
        }
      }
    }
  }
  .chapter-info {
    font-weight: 200;
    .chapter-name {
      color: #fff;
      font-size: 22px;
    }
    .chapter-brief {
      color: #a4a5a6;
    }
  }
  .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-left: -1.5em;
  }
  @media (min-width: 768px) {
    .video-js .vjs-big-play-button {
      font-size: 3rem;
      height: 5rem;
    }
  }
  .con-vs-dialog .vs-dialog {
    max-width: 600px !important;
  }
  .sidebar-btn {
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 8888;
    border-radius: 6px 0 0 6px;
  }
  
  
</style>
